module.exports = __webpack_public_path__ + "img/worldmatch.61bdd4c6.png";